class TeacherViewReport {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS) {

         let self = this;
         this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //String - Question paper id
        let qpId = $stateParams.qpId;

        //[String] - label for question vs no of students
        $scope.questionLabels = [];

        //[String] - label for question vs no of students tooltip
        $scope.questionTooltipLabels = [];

        //[Number] - data for question vs no of students
        $scope.quesAttendedStudentsCount = [];

        //[String] - label for tag vs no of students
        $scope.questionTags = [];

        //[Number] - data for tag vs no of students
        $scope.tagAttendedStudentsCount = [];

        //[Number] - data for tag vs no of Questions
        $scope.tagQuesCount = [];

        //[String] - label for Wave vs no of students
        $scope.questionWave = [];

        //[Number] - data for Wave vs no of students
        $scope.waveAttendedStudentsCount = [];

        //[Number] - data for Wave vs no of questions
        $scope.waveQuesCount = [];

        //[String] - label for Level vs no of students
        $scope.questionLevel = [];

        //[Number] - data for Level vs no of students
        $scope.levelAttendedStudentsCount = [];

        //[Number] - data for student vs mark
        $scope.mark = [];

        //[String] - label for student vs rank
        $scope.studentList = [];

        //[Number] - data for student vs rank
        $scope.rank = [];

        //[Object] - Contains chart data
        $scope.chartArray = []

        //Number - To set width of chart
        $scope.chartWidth = 530;

        //Number - To set height of chart
        $scope.chartHeight = 350;

        //[Object] - Holds list of chart details
        $scope.chartImgData = []

        //[Object] - chart availability
        $scope.chartAvailability = {
            isQuesVsStudent: false
        }

    

        $scope.barOptions = {
            responsive: true,
            scaleBeginAtZero: true,
            scaleShowGridLines: false,
            barValueSpacing: 1,
            barDatasetSpacing: 1,
            tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
            legend: {
                display: false,
            },
            scales: {
                xAxes: [{
                    barPercentage: 0.9,
                    categoryPercentage: 0.5
                }],
                yAxes: [{
                    ticks: {
                        stepSize: 1,
                        beginAtZero: true // minimum value will be 0.
                    }
                }]
            },
        }

        /*
         * Function to go back to activity page
         *
         * @return - null
         *
         */
        $scope.goBack = () => {
            let params = $stateParams.prevParams;
            $state.go("wizard.activityReport", params)
        }

        function convertFileToDataURLviaFileReader(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        };

        /*
         * To get chart details from Child chart component
         * 
         * @data : Object - Chart details
         * 
         * @return : null
         */
        $scope.getChartData = function(data) {
            if (data != undefined && data[0] != undefined) {
                $scope.chartImgData.push(data[0])
            }
        }

        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
        $scope.exportAsPDF = function() {
            var doc = new jsPDF('p', 'pt', 'a4', false) /* Creates a new Document*/
            doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
            doc.setFontSize(18);
            doc.setFontType('bold');
            var xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2);
            doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
            doc.setFontSize(12);
            doc.setFontType('normal');
            doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
            doc.setFontSize(16);
            doc.text(220, 90, 'Activity Based Report');
            doc.setFontSize(15); /* Define font size for the document */
            var yAxis = 150;

            for (var i = 0; i < $scope.chartImgData.length; i++) {
                if (i % 2 == 0 && i != 0) { /* I want only two images in a page */
                    doc.addPage(); /* Adds a new page*/
                    yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
                }

                var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
                var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

                if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                    width = doc.internal.pageSize.width;
                } else {
                    width = $scope.chartImgData[i].width;
                }

                height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
                height = width * (3 / 4) - 100

                var someText = (i + 1) + ".) " + $scope.chartImgData[i].title;
                doc.text(60, yAxis, someText); /* Add some text in the PDF */
                yAxis = yAxis + 20; /* Update yAxis */
                //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
                doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
                yAxis = yAxis + 360; /* Update yAxis */
            }
            window.open(doc.output('bloburl'))
                // doc.save('Activity_Based_Report.pdf')
        }


    }
}

export default TeacherViewReport


// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/teacherViewReport.js